<template>
  <ancestryline-modal title="forms.public-client.modal-send-notification.title" id="modal-responsible-public-client-form" :close="false" :closeable="false" :loading="false">
    <form @submit.prevent="save">
      <card class="p-col-12" >
          <coff-input-text-editor v-model="message" label="forms.public-client.modal-send-notification.label" class="p-col-12" />
      </card>
    </form>

    <template #footer>
      <div class="p-col-12">
        <Button :label="$t('btn.cancel')" @click.prevent="close" type="button" class="p-mt-2 p-ml-auto p-button-outlined p-button-secondary"/>
        <Button :label="$t('btn.send')" @click.prevent="save" style="float: right;margin-top: 8px;"/>
      </div>
    </template>

  </ancestryline-modal>
</template>

<script>
import DialogService from "@/business/ModalBusiness";

export default {
  name: "ModalClientNotification",

  data(){
    return{
        message: "",
    }
  },

  methods:{

    close(){
      DialogService.closeModal();
    },

    save(){
      DialogService.closeModal(this.message);
    },

  },

}
</script>

<style scoped>

</style>